import { AfterViewInit, Directive, Host, Input, OnDestroy } from '@angular/core';
import { DialogService } from '@app/core/services/dialog/dialog.service';
import { ButtonComponent } from '@components/buttons/button/button.component';
import { Subject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Directive({
  selector: '[vfsSubmit]'
})
export class SubmitDirective implements AfterViewInit, OnDestroy {
  @Input() submitSubject$: Subject<boolean>;
  @Input() showWaitDialog = false;

  subscription: Subscription;

  constructor(@Host() private parent: ButtonComponent, protected dialogService: DialogService) {}

  ngAfterViewInit(): void {
    let waitDialog = null;
    this.subscription = this.submitSubject$
      .pipe(
        tap(disabled => {
          if (disabled && this.showWaitDialog) {
            waitDialog = this.dialogService.wait();
          } else if (!disabled && this.showWaitDialog && waitDialog) {
            waitDialog.close();
          }
          this.parent.disabled = disabled;
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
